import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '@intigral/domain/lib/DataDomain';
import { IMpxService } from '@intigral/domain/lib/application/services/MpxService';
import { Carousel } from '@intigral/domain/lib/core/entities/ScreenEntities';
import { IApiPathManager } from '@intigral/domain/lib/infrastructures/config/ApiPathManager';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { getCountry } from '../../helpers/common';

const fetchMpxFeed = async (carousel: Carousel) => {
    const carouselDataSource = carousel.dataSources?.[0] ?? '';
    const apiPathManager = container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    const url = apiPathManager.replacePlaceholders(carouselDataSource);
    const mpxService = container.resolve<IMpxService>(DI.SERVICES.IMpxService);

    return mpxService.getFeed(url, {
        byCustomValue: `{PC}{${getCountry()}}`,
    });
};

export const useMpxFeed = (carousel: Carousel) => {
    const location = useLocation();

    return useQuery({
        queryKey: ['mpxFeed', carousel.id, carousel.dataSources?.[0], location.search],
        queryFn: () => fetchMpxFeed(carousel),
        staleTime: 10 * 60 * 1000, // Consider data stale after 10 minutes
        //cacheTime: 30 * 60 * 1000, // Keep data in cache for 30 minutes
    });
};
